import * as React from "react";
import { forwardRef } from "react";
const SvgPlus = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, viewBox: "0 0 32 32", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6.667 17.333h8v8a1.333 1.333 0 0 0 2.666 0v-8h8a1.333 1.333 0 0 0 0-2.666h-8v-8a1.333 1.333 0 0 0-2.666 0v8h-8a1.333 1.333 0 0 0 0 2.666Z" }));
const ForwardRef = forwardRef(SvgPlus);
export default ForwardRef;
